import { Model, ModelData } from 'src/containers/ProjectDiagram/types/model';
import { setDataProperty } from 'src/containers/ProjectDiagram/utils/setDataProperty';

export const updateModelLabelIris =
  (prevIri: string, newIri: string) => (model: Model) => {
    const labelsByIri = Object.entries(model.modelData.labelsByIri).reduce<
      Record<string, string>
    >((acc, [prevLabelIri, prevLabel]) => {
      const labelIri = prevLabelIri === prevIri ? newIri : prevLabelIri;
      acc[labelIri] = prevLabel;
      return acc;
    }, {});
    setDataProperty<ModelData>(model)(
      model.modelData,
      'labelsByIri',
      labelsByIri
    );
  };
